/*
  DESTINO NO SHOPIFY: assets/custom.js
  Substitua todo o conteúdo existente por este código.
  Preparado a partir do tema exportado em 18/07/2026 às 16:52.
*/
(function () {
  'use strict';

  if (window.__catexShippingControllerV2Init) return;

  var pagePath = window.location.pathname.replace(/\/$/, '') || '/';
  var isProductPage = pagePath.indexOf('/products/') !== -1;
  var isCartPage = /\/cart$/.test(pagePath);

  if (!isProductPage && !isCartPage) return;

  window.__catexShippingControllerV2Init = true;

  var REQUEST_PATH = '/apps/cotafrete/get_rates';
  var RECALCULATE_DELAY = 800;
  var REQUEST_TIMEOUT = 15000;
  var STORAGE_CEP = 'catex_shipping_cep';
  var STORAGE_ENABLED = 'catex_shipping_auto_enabled';

  var CEP_SELECTOR = [
    'input[placeholder*="CEP" i]',
    'input[name*="cep" i]',
    'input[id*="cep" i]',
    'input[aria-label*="CEP" i]',
    'input[name*="zip" i]',
    'input[id*="zip" i]',
    'input[name*="postal" i]',
    'input[id*="postal" i]'
  ].join(',');

  var PRODUCT_QUANTITY_BUTTON_SELECTOR = [
    '.catex-minus',
    '.catex-plus',
    '.catex-atalho',
    '.catex-unit-minus',
    '.catex-unit-plus',
    '.catex-unit-atalho',
    'quantity-selector-component button[name="minus"]',
    'quantity-selector-component button[name="plus"]'
  ].join(',');

  var PRODUCT_QUANTITY_INPUT_SELECTOR = [
    '#catex-input-display',
    '#catex-unit-input-display',
    'quantity-selector-component input[name="quantity"]:not([data-cart-line])'
  ].join(',');

  var CART_AREA_SELECTOR = [
    '.cart-page',
    'cart-drawer',
    '.cart-drawer',
    'cart-items-component[data-drawer]',
    '[data-cart-drawer]',
    '[data-drawer="true"]',
    'dialog[id*="cart" i]'
  ].join(',');

  var PRODUCT_SCOPE_SELECTOR = [
    '.product-information',
    '.product-information__grid',
    'product-information',
    '[data-section-type="product-information"]',
    '[id*="ProductInformation" i]'
  ].join(',');

  var STICKY_PRODUCT_SELECTOR = [
    'sticky-add-to-cart',
    '.sticky-add-to-cart',
    '[data-sticky-add-to-cart]'
  ].join(',');

  var NON_MAIN_PRODUCT_SELECTOR = [
    '.quick-add-modal',
    '[data-quick-add-modal]',
    'dialog[id*="quick" i]'
  ].join(',');

  var state = {
    cep: readSession(STORAGE_CEP),
    enabled: readSession(STORAGE_ENABLED) === '1',
    timer: null,
    watchdogTimer: null,
    activeRequests: 0,
    pending: false,
    pendingReason: '',
    pendingContext: null,
    requestSequence: 0,
    latestRequestId: 0,
    revision: 0,
    lastAttemptSignature: '',
    lastSuccessfulSignature: '',
    lastContext: null,
    lastQuote: null,
    autoAttempt: null,
    autoWindowUntil: 0,
    programmaticClick: false,
    manualClickLockedUntil: 0
  };

  installStyles();

  function readSession(key) {
    try {
      return window.sessionStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // O simulador continua funcionando quando o sessionStorage está bloqueado.
    }
  }

  function installStyles() {
    if (document.getElementById('catex-shipping-controller-v2-styles')) return;

    var style = document.createElement('style');
    style.id = 'catex-shipping-controller-v2-styles';
    style.textContent = [
      '.catex-shipping-calculator .catex-shipping-field {',
      'border:1px solid #000!important;color:#000!important;background:#fff!important;box-shadow:none!important;',
      '}',
      '.catex-shipping-calculator .catex-shipping-submit {',
      'border:1px solid #000!important;background:#fff!important;color:#000!important;box-shadow:none!important;',
      '}',
      '.catex-shipping-calculator .catex-shipping-submit:hover {',
      'color:#777!important;background:#fff!important;border-color:#000!important;',
      '}',
      '.catex-shipping-status,.catex-free-shipping-hint {',
      'box-sizing:border-box;display:block!important;flex:0 0 100%!important;grid-column:1/-1!important;',
      'width:100%!important;min-width:0;max-width:100%;clear:both;',
      '}',
      '.catex-shipping-status {',
      'margin:8px 0 4px;padding:8px 10px;border-radius:8px;background:#f6f6f6;color:#666;',
      'font-size:.82rem;line-height:1.3;',
      '}',
      '.catex-shipping-status[data-state="error"] {background:#fff0f0;color:#8a2020;}',
      '.catex-free-shipping-hint {',
      'margin:12px 0;padding:11px 13px;border:1px solid rgba(0,0,0,.12);border-radius:10px;',
      'background:#fff8d8;color:#2f2f2f;font-family:Inter,var(--font-body--family),sans-serif;',
      'font-size:.92rem;line-height:1.35;',
      '}',
      '.catex-free-shipping-hint strong {font-weight:800;}'
    ].join('');

    document.head.appendChild(style);
  }

  function onlyDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function isValidCep(value) {
    return onlyDigits(value).length === 8;
  }

  function formatCep(value) {
    var digits = onlyDigits(value).slice(0, 8);
    return digits.length === 8 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function normalizeText(value) {
    var text = String(value || '').toLowerCase();
    if (typeof text.normalize === 'function') {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return text.replace(/\s+/g, ' ').trim();
  }

  function getOwnText(element) {
    if (!element) return '';

    return Array.prototype.slice.call(element.childNodes).map(function (node) {
      return node.nodeType === Node.TEXT_NODE ? node.textContent : '';
    }).join(' ');
  }

  function isPickupRateElement(element) {
    var text = normalizeText(element && element.textContent);
    return (
      text.indexOf('retirar na loja') !== -1 ||
      text.indexOf('retirada na loja') !== -1 ||
      text.indexOf('retire na loja') !== -1 ||
      text.indexOf('retira na loja') !== -1
    );
  }

  function isPickupRateTitle(element) {
    var text = normalizeText(getOwnText(element) || (element && element.textContent));
    return (
      text.indexOf('retirar na loja') !== -1 ||
      text.indexOf('retirada na loja') !== -1 ||
      text.indexOf('retire na loja') !== -1 ||
      text.indexOf('retira na loja') !== -1
    );
  }

  function isCarrierRateElement(element) {
    if (!element || element.matches('script, style, template')) return false;
    if (element.querySelector(CEP_SELECTOR)) return false;

    var text = normalizeText(element.textContent);
    if (!text) return false;

    return /\b(pac|sedex|jadlog|loggi)\b/.test(text) ||
      text.indexOf('transportadora') !== -1 ||
      text.indexOf('correios') !== -1;
  }

  function getRateStopElement(parent) {
    var children = Array.prototype.slice.call(parent.children);

    for (var index = 0; index < children.length; index += 1) {
      var text = normalizeText(children[index].textContent);
      if (text === 'desconto' || text.indexOf('cupom') !== -1) return children[index];
    }

    return null;
  }

  function restorePickupRateTextOrder(title) {
    var previous = title && title.previousElementSibling;
    if (!previous) return;

    var previousText = normalizeText(previous.textContent);
    if (previousText.indexOf('polo textil') !== -1 || previousText.indexOf('dias uteis') !== -1) {
      title.parentElement.insertBefore(title, previous);
    }
  }

  function getFlatPickupGroup(title) {
    var parent = title.parentElement;
    if (!parent) return null;

    var siblings = Array.prototype.slice.call(parent.children);
    if (!siblings.some(isCarrierRateElement)) return null;

    var startIndex = siblings.indexOf(title);
    if (startIndex === -1) return null;

    var nodes = [title];
    for (var index = startIndex + 1; index < siblings.length; index += 1) {
      if (
        isCarrierRateElement(siblings[index]) ||
        isPickupRateTitle(siblings[index]) ||
        normalizeText(siblings[index].textContent) === 'desconto'
      ) {
        break;
      }
      nodes.push(siblings[index]);
    }

    return {
      parent: parent,
      nodes: nodes,
      before: getRateStopElement(parent)
    };
  }

  function getPickupRateMove(element, root) {
    var current = element;

    while (current && current !== root && current !== document.body) {
      var parent = current.parentElement;
      if (!parent) break;

      var siblings = Array.prototype.slice.call(parent.children);
      var carrierSiblings = siblings.filter(isCarrierRateElement);

      if (carrierSiblings.length > 0 && siblings.indexOf(current) !== -1 && isPickupRateElement(current)) {
        return {
          parent: parent,
          row: current,
          before: getRateStopElement(parent)
        };
      }

      current = parent;
    }

    return null;
  }

  function sortPickupRates(root) {
    if (!root || !root.querySelectorAll) return;

    var pickupNodes = Array.prototype.slice.call(root.querySelectorAll('*')).filter(function (element) {
      return isPickupRateTitle(element) &&
        !Array.prototype.some.call(element.children, isPickupRateTitle);
    });

    pickupNodes.forEach(function (node) {
      restorePickupRateTextOrder(node);

      var flatGroup = getFlatPickupGroup(node);
      if (flatGroup && flatGroup.nodes.length > 1) {
        flatGroup.nodes.forEach(function (groupNode) {
          flatGroup.parent.insertBefore(groupNode, flatGroup.before);
        });
        return;
      }

      var move = getPickupRateMove(node, root);
      if (move) move.parent.insertBefore(move.row, move.before);
    });
  }

  function formatMoney(cents) {
    return (Math.max(0, cents) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function parseMoneyText(value) {
    var matches = String(value || '').match(/\d[\d.]*,\d{2}/g);
    if (!matches || !matches.length) return 0;
    return parseInt(matches[matches.length - 1].replace(/\D/g, ''), 10) || 0;
  }

  function getVisibleTotalCents() {
    var candidates = [
      document.querySelector('[data-cart-subtotal]'),
      document.querySelector('[data-testid="cart-total-value"]'),
      document.querySelector('.cart__total-value'),
      document.querySelector('[ref="cartTotal"]'),
      document.getElementById('catex-total'),
      document.getElementById('catex-unit-total'),
      document.querySelector('.catex-unit-total-valor')
    ];

    for (var index = 0; index < candidates.length; index += 1) {
      if (!candidates[index]) continue;
      var cents = parseMoneyText(candidates[index].textContent);
      if (cents > 0) return cents;
    }

    return 0;
  }

  function getFreeShippingMinimum(cep) {
    var digits = onlyDigits(cep);
    if (digits.length < 5) return null;

    var prefix = parseInt(digits.slice(0, 5), 10);
    if (Number.isNaN(prefix)) return null;

    if (prefix >= 1000 && prefix <= 39999) return 55000;
    if ((prefix >= 70000 && prefix <= 76799) || (prefix >= 78000 && prefix <= 99999)) return 65000;
    if ((prefix >= 40000 && prefix <= 69999) || (prefix >= 76800 && prefix <= 77999)) return 80000;
    return null;
  }

  function isShippingRequest(url) {
    try {
      return new URL(String(url), window.location.origin).pathname.indexOf(REQUEST_PATH) !== -1;
    } catch (error) {
      return false;
    }
  }

  function getFirstParam(searchParams, names) {
    for (var index = 0; index < names.length; index += 1) {
      var value = searchParams.get(names[index]);
      if (value !== null && value !== '') return value;
    }
    return '';
  }

  function getActiveCep() {
    if (state.lastContext && state.lastContext.field && document.contains(state.lastContext.field)) {
      var contextCep = onlyDigits(state.lastContext.field.value);
      if (contextCep.length === 8) return contextCep;
    }

    var fields = document.querySelectorAll(CEP_SELECTOR);
    for (var index = 0; index < fields.length; index += 1) {
      var fieldCep = onlyDigits(fields[index].value);
      if (fieldCep.length === 8) return fieldCep;
    }

    return onlyDigits(state.cep);
  }

  function parseQuote(url) {
    try {
      var parsed = new URL(String(url), window.location.origin);
      if (parsed.pathname.indexOf(REQUEST_PATH) === -1) return null;

      var cep = getFirstParam(parsed.searchParams, [
        'cep', 'zip', 'zipcode', 'zip_code', 'postal_code',
        'destination_zip', 'destination_postal_code'
      ]);

      var totalValue = getFirstParam(parsed.searchParams, [
        'total_value', 'subtotal', 'cart_total', 'value', 'price'
      ]);

      return {
        cep: onlyDigits(cep) || getActiveCep(),
        totalCents: parseInt(onlyDigits(totalValue), 10) || getVisibleTotalCents(),
        time: Date.now()
      };
    } catch (error) {
      return null;
    }
  }

  function isConsultButton(button) {
    if (!button || !button.matches) return false;
    if (!button.matches('button, input[type="button"], input[type="submit"]')) return false;

    var label = normalizeText(
      button.textContent || button.value || button.getAttribute('aria-label')
    );

    return /consultar|calcular|cotacao|cotar/.test(label);
  }

  function findConsultButton(root, field) {
    if (!root) return null;

    var form = field && field.closest ? field.closest('form') : null;
    var scope = form && root.contains(form) ? form : root;
    var buttons = scope.querySelectorAll('button, input[type="button"], input[type="submit"]');

    for (var index = 0; index < buttons.length; index += 1) {
      if (isConsultButton(buttons[index])) return buttons[index];
    }

    return null;
  }

  function getCalculatorRoot(field) {
    if (!field) return null;

    var preferred = field.closest([
      'shopify-app-block', '.shopify-app-block', '.shopify-block', '[data-app-block]',
      '[id*="cota" i]', '[class*="cota" i]', '[id*="kokfy" i]', '[class*="kokfy" i]'
    ].join(','));

    if (preferred && findConsultButton(preferred, field)) return preferred;

    var current = field.parentElement;
    var best = null;
    var depth = 0;

    while (current && current !== document.body && depth < 10) {
      if (findConsultButton(current, field)) {
        best = current;
        if (/frete|entrega|cep/.test(normalizeText(current.textContent))) return current;
      }

      if (current.matches('.product-information, .cart-page, main, .shopify-section')) break;
      current = current.parentElement;
      depth += 1;
    }

    return best;
  }

  function buildContext(field) {
    if (!field) return null;

    var root = getCalculatorRoot(field);
    if (!root) return null;

    var button = findConsultButton(root, field);
    if (!button) return null;

    var context = { root: root, field: field, button: button };
    markContext(context);
    return context;
  }

  function markContext(context) {
    if (!context || !context.root || !context.field || !context.button) return;
    context.root.classList.add('catex-shipping-calculator');
    context.field.classList.add('catex-shipping-field');
    context.button.classList.add('catex-shipping-submit');
  }

  function findContext(cep, preferredScope) {
    var digits = onlyDigits(cep);
    var scope = preferredScope && preferredScope.querySelectorAll ? preferredScope : document;
    var fields = scope.querySelectorAll(CEP_SELECTOR);
    var fallback = null;

    for (var index = 0; index < fields.length; index += 1) {
      var context = buildContext(fields[index]);
      if (!context) continue;
      if (!fallback) fallback = context;
      if (digits && onlyDigits(fields[index].value) === digits) return context;
    }

    if (!preferredScope && state.lastContext && document.contains(state.lastContext.root)) {
      markContext(state.lastContext);
      return state.lastContext;
    }

    return fallback;
  }

  function placeAfterCalculatorForm(context, element) {
    if (!context || !context.root || !element) return;

    var form = context.field.closest('form');
    if (form && context.root.contains(form) && form.parentNode) {
      if (element.parentNode !== form.parentNode || element.previousElementSibling !== form) {
        form.insertAdjacentElement('afterend', element);
      }
      return;
    }

    if (element.parentNode !== context.root) context.root.appendChild(element);
  }

  function getStatusElement(context) {
    if (!context || !context.root || !document.contains(context.root)) return null;

    var status = context.root.querySelector('[data-catex-shipping-status]');
    if (status) return status;

    status = document.createElement('div');
    status.className = 'catex-shipping-status';
    status.setAttribute('data-catex-shipping-status', '');
    status.setAttribute('aria-live', 'polite');
    placeAfterCalculatorForm(context, status);
    return status;
  }

  function showStatus(context, text, statusType) {
    var status = getStatusElement(context);
    if (!status) return;
    status.textContent = text;
    status.setAttribute('data-state', statusType || 'info');
  }

  function clearStatus(context) {
    if (!context || !context.root) return;
    var status = context.root.querySelector('[data-catex-shipping-status]');
    if (status) status.remove();
  }

  function renderFreeShippingHint(context, quote) {
    if (!context || !context.root || !quote || !isValidCep(quote.cep)) return;

    var minimum = getFreeShippingMinimum(quote.cep);
    var totalCents = quote.totalCents || getVisibleTotalCents();
    var existing = context.root.querySelector('[data-catex-free-shipping-hint]');

    if (!minimum || !totalCents || minimum <= totalCents) {
      if (existing) existing.remove();
      return;
    }

    var hint = existing || document.createElement('div');
    hint.className = 'catex-free-shipping-hint';
    hint.setAttribute('data-catex-free-shipping-hint', '');
    hint.innerHTML = 'Comprando mais <strong>' + formatMoney(minimum - totalCents) +
      '</strong> você tem <strong>FRETE GRÁTIS!</strong>';
    placeAfterCalculatorForm(context, hint);
  }

  function activateAutomaticShipping(cep, context) {
    var digits = onlyDigits(cep);
    if (digits.length !== 8) return;

    state.cep = digits;
    state.enabled = true;
    state.lastContext = context || state.lastContext;
    writeSession(STORAGE_CEP, digits);
    writeSession(STORAGE_ENABLED, '1');
  }

  function isInsideCartArea(element) {
    return !!(element && element.closest && element.closest(CART_AREA_SELECTOR));
  }

  function getProductScope(element) {
    if (element && element.closest) {
      var local = element.closest(PRODUCT_SCOPE_SELECTOR);
      if (local) return local;
    }
    return document.querySelector(PRODUCT_SCOPE_SELECTOR);
  }

  function getContextSignature(context) {
    var kind = context && isInsideCartArea(context.root) ? 'cart' : 'product';
    var scope = context && context.root && context.root.closest
      ? context.root.closest(PRODUCT_SCOPE_SELECTOR)
      : null;
    scope = scope || document;

    if (kind === 'cart' || isCartPage) {
      return 'cart:' + state.revision;
    }

    var variantField = scope.querySelector(
      'form[action*="/cart/add"] input[name="id"], input[name="id"][data-variant-id]'
    );
    var quantityField = scope.querySelector([
      '#catex-qty-native',
      '#catex-unit-qty-native',
      'quantity-selector-component input[name="quantity"]:not([data-cart-line])',
      'form[action*="/cart/add"] input[name="quantity"]'
    ].join(','));

    var variant = variantField ? variantField.value : '';
    var quantity = quantityField ? quantityField.value : '';
    return 'product:' + state.revision + ':' + variant + ':' + quantity;
  }

  function mergeQuote(primary, secondary) {
    primary = primary || {};
    secondary = secondary || {};

    return {
      cep: onlyDigits(secondary.cep || primary.cep || state.cep),
      totalCents: secondary.totalCents || primary.totalCents || getVisibleTotalCents(),
      time: Date.now()
    };
  }

  function setContextBusy(context, busy) {
    if (!context || !context.button) return;
    if (busy) {
      context.button.setAttribute('aria-busy', 'true');
    } else {
      context.button.removeAttribute('aria-busy');
    }
  }

  function clearAllContextBusyStates() {
    var buttons = document.querySelectorAll('.catex-shipping-submit[aria-busy="true"]');
    for (var index = 0; index < buttons.length; index += 1) {
      buttons[index].removeAttribute('aria-busy');
    }
  }

  function beginQuote(url) {
    var quote = parseQuote(url);
    if (!quote) return null;

    var context = findContext(quote.cep) || state.lastContext;
    var automatic = !!state.autoAttempt || Date.now() < state.autoWindowUntil;
    var signature = state.autoAttempt
      ? state.autoAttempt.signature
      : getContextSignature(context);

    if (isValidCep(quote.cep)) activateAutomaticShipping(quote.cep, context);

    if (state.autoAttempt) {
      state.autoAttempt.started = true;
      window.clearTimeout(state.watchdogTimer);
      state.watchdogTimer = null;
    }

    window.clearTimeout(state.timer);
    state.timer = null;
    state.activeRequests += 1;
    state.lastContext = context || state.lastContext;

    var meta = {
      id: state.requestSequence += 1,
      automatic: automatic,
      context: context,
      quote: quote,
      signature: signature,
      done: false,
      timeout: null
    };

    state.latestRequestId = meta.id;
    setContextBusy(context, true);
    if (automatic && context) showStatus(context, 'Atualizando o frete…');

    meta.timeout = window.setTimeout(function () {
      failQuote(meta, 'A consulta de frete demorou demais. Tente novamente.');
    }, REQUEST_TIMEOUT);

    return meta;
  }

  function completeRequest(meta) {
    if (!meta || meta.done) return false;
    meta.done = true;
    window.clearTimeout(meta.timeout);
    state.activeRequests = Math.max(0, state.activeRequests - 1);

    if (state.activeRequests === 0) {
      clearAllContextBusyStates();
      state.autoAttempt = null;
      state.autoWindowUntil = 0;

      if (state.pending) {
        var pendingContext = state.pendingContext;
        var pendingReason = state.pendingReason;
        state.pending = false;
        state.pendingContext = null;
        state.pendingReason = '';
        scheduleAutomaticQuote(pendingReason, pendingContext, false);
      }
    }

    return true;
  }

  function settleCalculator(context, quote) {
    if (!context || !context.root || !document.contains(context.root)) return;

    var observer = null;
    var quietTimer = null;
    var finalTimer = null;
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      window.clearTimeout(quietTimer);
      window.clearTimeout(finalTimer);
      if (observer) observer.disconnect();
      markContext(context);
      sortPickupRates(context.root);
      renderFreeShippingHint(context, quote);
      clearStatus(context);
    }

    if (window.MutationObserver) {
      observer = new MutationObserver(function () {
        window.clearTimeout(quietTimer);
        quietTimer = window.setTimeout(finish, 100);
      });
      observer.observe(context.root, { childList: true, subtree: true });
    }

    quietTimer = window.setTimeout(finish, 250);
    finalTimer = window.setTimeout(finish, 1200);
  }

  function finalizeQuote(meta, finalUrl) {
    if (!meta || meta.done) return;

    var finalQuote = mergeQuote(meta.quote, parseQuote(finalUrl));
    var context = meta.context || findContext(finalQuote.cep) || state.lastContext;

    if (meta.id === state.latestRequestId) {
      state.lastQuote = finalQuote;
      state.lastContext = context || state.lastContext;
      state.lastSuccessfulSignature = meta.signature;
      if (isValidCep(finalQuote.cep)) activateAutomaticShipping(finalQuote.cep, context);
      settleCalculator(context, finalQuote);
    }

    completeRequest(meta);
  }

  function failQuote(meta, message) {
    if (!meta || meta.done) return;

    if (meta.id === state.latestRequestId && meta.context) {
      showStatus(
        meta.context,
        message || 'Não foi possível atualizar o frete. Use o botão Consultar.',
        'error'
      );
    }

    completeRequest(meta);
  }

  function scheduleAutomaticQuote(reason, context, incrementRevision) {
    if (!state.enabled || !isValidCep(state.cep)) return;

    if (incrementRevision !== false) state.revision += 1;
    context = context || state.lastContext || findContext(state.cep);
    if (!context || !context.root || !document.contains(context.root)) return;

    state.lastContext = context;
    state.pendingContext = context;
    state.pendingReason = reason || 'alteração de quantidade';

    window.clearTimeout(state.timer);

    if (state.activeRequests > 0) {
      state.pending = true;
      showStatus(context, 'Quantidade alterada. O frete será atualizado ao terminar a consulta atual…');
      return;
    }

    showStatus(context, 'Quantidade alterada. Atualizando o frete…');
    state.timer = window.setTimeout(function () {
      state.timer = null;
      runAutomaticQuote(context);
    }, RECALCULATE_DELAY);
  }

  function runAutomaticQuote(context) {
    if (!state.enabled || !isValidCep(state.cep)) return;

    if (document.hidden) {
      state.pending = true;
      state.pendingContext = context;
      return;
    }

    if (state.activeRequests > 0) {
      state.pending = true;
      state.pendingContext = context;
      return;
    }

    if (!context || !document.contains(context.root)) {
      context = findContext(state.cep);
    }
    if (!context || !context.field || !context.button) return;

    var signature = getContextSignature(context);
    if (signature === state.lastSuccessfulSignature || signature === state.lastAttemptSignature) {
      return;
    }

    state.lastContext = context;
    state.lastAttemptSignature = signature;
    state.autoAttempt = { signature: signature, context: context, started: false };
    state.autoWindowUntil = Date.now() + 3000;

    if (onlyDigits(context.field.value) !== state.cep) {
      context.field.value = formatCep(state.cep);
    }

    showStatus(context, 'Atualizando o frete…');

    state.programmaticClick = true;
    try {
      context.button.click();
    } finally {
      state.programmaticClick = false;
    }

    window.clearTimeout(state.watchdogTimer);
    state.watchdogTimer = window.setTimeout(function () {
      if (state.autoAttempt && !state.autoAttempt.started) {
        state.autoAttempt = null;
        state.autoWindowUntil = 0;
        showStatus(
          context,
          'Não foi possível iniciar a atualização automática. Clique em Consultar.',
          'error'
        );
      }
    }, 2500);
  }

  function contextFromButton(button) {
    if (!isConsultButton(button)) return null;

    var form = button.closest('form');
    var field = form ? form.querySelector(CEP_SELECTOR) : null;
    if (field) return buildContext(field);

    var current = button.parentElement;
    var depth = 0;
    while (current && current !== document.body && depth < 8) {
      field = current.querySelector(CEP_SELECTOR);
      if (field) return buildContext(field);
      if (current.matches('.product-information, .cart-page, main, .shopify-section')) break;
      current = current.parentElement;
      depth += 1;
    }

    return null;
  }

  function getProductContextFromTarget(target) {
    if (!isProductPage || !target || isInsideCartArea(target)) return null;
    if (target.closest && target.closest(NON_MAIN_PRODUCT_SELECTOR)) return null;

    var productScope = target.closest ? target.closest(PRODUCT_SCOPE_SELECTOR) : null;
    var isStickySelector = !!(target.closest && target.closest(STICKY_PRODUCT_SELECTOR));
    if (!productScope && !isStickySelector) return null;

    productScope = productScope || getProductScope();
    return findContext(state.cep, productScope) || state.lastContext || findContext(state.cep);
  }

  // Bloqueia apenas cliques manuais repetidos enquanto uma consulta está em andamento.
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('button, input[type="button"], input[type="submit"]')
      : null;

    if (!button || !isConsultButton(button) || state.programmaticClick) return;

    if (state.activeRequests > 0 || Date.now() < state.manualClickLockedUntil) {
      event.preventDefault();
      event.stopPropagation();
      var context = contextFromButton(button) || state.lastContext;
      if (context) showStatus(context, 'Aguarde a consulta de frete atual terminar…');
      return;
    }

    state.manualClickLockedUntil = Date.now() + 1200;
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('button, input[type="button"], input[type="submit"]')
      : null;

    if (button && isConsultButton(button)) {
      if (!state.programmaticClick) {
        var context = contextFromButton(button);
        if (context) {
          var cep = onlyDigits(context.field.value);
          if (cep.length === 8) {
            activateAutomaticShipping(cep, context);
            window.clearTimeout(state.timer);
            state.timer = null;
            state.pending = false;
          }
        }
      }
      return;
    }

    if (!event.target || !event.target.closest) return;
    if (!event.target.closest(PRODUCT_QUANTITY_BUTTON_SELECTOR)) return;

    var productContext = getProductContextFromTarget(event.target);
    if (!productContext) return;

    window.setTimeout(function () {
      scheduleAutomaticQuote('alteração de quantidade do produto', productContext, true);
    }, 0);
  });

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.matches) return;

    if (event.target.matches(CEP_SELECTOR)) {
      var cep = onlyDigits(event.target.value);
      if (state.enabled && cep.length === 8) {
        state.cep = cep;
        state.lastContext = buildContext(event.target) || state.lastContext;
        writeSession(STORAGE_CEP, cep);
      }
      return;
    }

    if (!event.target.matches(PRODUCT_QUANTITY_INPUT_SELECTOR)) return;
    var productContext = getProductContextFromTarget(event.target);
    if (productContext) {
      scheduleAutomaticQuote('quantidade digitada no produto', productContext, true);
    }
  });

  document.addEventListener('quantity-selector:update', function (event) {
    // Eventos com cartLine pertencem ao carrinho; aguardamos cart:update/cart:updated.
    if (event.detail && event.detail.cartLine) return;
    var context = getProductContextFromTarget(event.target);
    if (context) scheduleAutomaticQuote('seletor de quantidade do produto', context, true);
  });

  document.addEventListener('variant:update', function (event) {
    var context = getProductContextFromTarget(event.target) || findContext(state.cep, getProductScope());
    if (context) scheduleAutomaticQuote('alteração de variante', context, true);
  });

  document.addEventListener('variant:changed', function (event) {
    var context = getProductContextFromTarget(event.target) || findContext(state.cep, getProductScope());
    if (context) scheduleAutomaticQuote('alteração de variante personalizada', context, true);
  });

  function handleCartUpdated(event) {
    // Em páginas de produto, uma alteração no drawer não pode clicar no simulador do produto.
    if (!isCartPage) return;

    window.setTimeout(function () {
      var cartScope = document.querySelector('.cart-page') || document;
      var context = findContext(state.cep, cartScope);
      if (context) scheduleAutomaticQuote('atualização do carrinho', context, true);
    }, 250);
  }

  document.addEventListener('cart:update', handleCartUpdated);
  document.addEventListener('cart:updated', handleCartUpdated);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && state.pending && state.pendingContext) {
      var context = state.pendingContext;
      state.pending = false;
      scheduleAutomaticQuote(state.pendingReason || 'retorno à página', context, false);
    }
  });

  var originalFetch = window.fetch;

  if (typeof originalFetch === 'function') {
    window.fetch = function (resource, options) {
      var requestUrl = typeof Request !== 'undefined' && resource instanceof Request
        ? resource.url
        : resource;
      var meta = isShippingRequest(requestUrl) ? beginQuote(requestUrl) : null;
      var promise;

      try {
        promise = originalFetch.apply(this, arguments);
      } catch (error) {
        if (meta) failQuote(meta);
        throw error;
      }

      if (!meta) return promise;

      return promise.then(function (response) {
        try {
          if (response && response.ok === false) {
            failQuote(meta, 'O serviço de frete retornou um erro. Tente novamente.');
          } else {
            finalizeQuote(meta, response && response.url ? response.url : requestUrl);
          }
        } catch (controllerError) {
          failQuote(meta);
        }
        return response;
      }, function (error) {
        failQuote(meta);
        throw error;
      });
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url) {
    var meta = isShippingRequest(url) ? beginQuote(url) : null;

    if (meta) {
      this.addEventListener('loadend', function () {
        if (this.status >= 200 && this.status < 400) {
          finalizeQuote(meta, this.responseURL || url);
        } else {
          failQuote(meta);
        }
      }, { once: true });
    }

    try {
      return originalOpen.apply(this, arguments);
    } catch (error) {
      if (meta) failQuote(meta);
      throw error;
    }
  };

  function initializeContext() {
    var scope = isCartPage ? (document.querySelector('.cart-page') || document) : getProductScope();
    var context = findContext(state.cep, scope);
    if (!context) return;

    state.lastContext = context;
    if (isValidCep(state.cep) && !isValidCep(context.field.value)) {
      context.field.value = formatCep(state.cep);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeContext, { once: true });
  } else {
    initializeContext();
  }
})();
